/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const CheckboxIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 16 16"
    onClick={props.onClick}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <polyline points="13.6666667 4 4.91666667 12.1666667 2 9.25" />
    </g>
  </svg>
);

export default CheckboxIcon;
